module.exports = __webpack_public_path__ + "img/agree.3d0ff88f.png";